import { useWatch } from 'react-hook-form';
import { BookingSlot } from '../../../hooks/site/useSiteHourRange';
import { WaitingListFormValues } from '../../../hooks/patient/waitingList/useWaitingList';
import { SelectOption } from '../../../types/common';

const hourToSelect = (hour: number) => ({
  key: hour,
  label: String(hour),
  value: hour,
});

export const useWaitingListRowData = ({
  index,
  slots,
  closeHour,
}: {
  index: number;
  slots: BookingSlot[];
  closeHour: number;
}) => {
  const hourRange = slots.map((slot) => slot.hour);
  const hourFrom = useWatch<WaitingListFormValues, `list.${number}.hourFrom`>({
    name: `list.${index}.hourFrom`,
  });
  const hourTo = useWatch<WaitingListFormValues, `list.${number}.hourTo`>({
    name: `list.${index}.hourTo`,
  });
  const hourFromOptions: SelectOption<number>[] = hourRange.map(hourToSelect);
  const hourToOptionsValues = hourFrom
    ? [...hourRange, closeHour].filter((hour) => hour > hourFrom)
    : [...hourRange, closeHour].slice(1); // remove the site open hour, as open hour cannot be "Hour to"
  const hourToOptions = hourToOptionsValues.map(hourToSelect);

  return {
    hourTo,
    hourFromOptions,
    hourToOptions,
  };
};
